<template>
  <div>
    <div>
      <div class="d-flex align-center mt-1 mb-4">
        <div class="d-flex"><p class="ma-0 mr-2">지연시간</p></div>
        <div class="flex-grow-1">
          <DelaySlider :cmd="cmd" @change="onChangeDelay"></DelaySlider>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex align-center mt-1 mb-4">
        <div class="d-flex"><p class="ma-0 mr-2">자막색상</p></div>
        <div v-for="(c, i) in colors" :key="i">
          <v-chip class="elevation-4 ma-1" :color="c" @click="onChangeColor(c)">
            {{ c === style.color ? "✔" : "" }}
          </v-chip>
        </div>
      </div>
    </div>

    <div class="mt-1 d-flex flex-wrap" v-for="(t, i) in textTypeSchemas" :key="i">
      <v-text-field
        v-model="t.template"
        @change="onChangeText"
        outlined
        dense
        hide-details
        append-icon="mdi-close"
        @click:append="textTypeSchemas.splice(i, 1)"
      ></v-text-field>
    </div>
    <div class="mt-2">
      <v-btn @click="onClickAddItem" block small>추가하기 + </v-btn>
    </div>
  </div>
</template>

<script>
const TEXT_ANIME_CMD_SCHEMA = {};
import { SUPPORT_COLORS } from "../../../constants/MOD_SETTINGS";

// NOTE:
// 이벤트가 변할때마다 add나 textchange
// cmd를 만들어서 내보는게 좋을 것 같다
// 왜냐하면?
// 부모에서 감시를 하고, 이걸 저장할지 말지는 부모의 역할
// 양방향으로 최대한 맞게 해놓자

// delay 하고 색깔

export default {
  model: {
    prop: "cmd",
    event: "input",
  },
  props: {
    cmd: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      colors: [...SUPPORT_COLORS],

      style: {
        color: null,
      },
      delay: 0,
      textTypeSchemas: [],
    };
  },
  // mounted() {
  //   this.textTypeSchemas = [];
  //   this.$emit("input", this.makeOneCmd());
  // },
  methods: {
    // External
    makeOneCmd() {
      const argSchema1 = this.textTypeSchemas.map((schema) => ({
        ...schema, // 이게 뒤에 있으면 덮어 써진다.. 새 컬러를 만들어야 하는데 이놈아...
        style: this.style,
      }));

      return {
        _type: "text",
        targetRef: "textAnime",
        delay: this.delay,
        argSchema1,
      };
    },
    // EVENT
    onClickAddItem() {
      this.textTypeSchemas.push({ template: "" });
      this.$emit("input", this.makeOneCmd());
    },
    onChangeText() {
      this.$emit("input", this.makeOneCmd());
    },
    onChangeDelay(delay_ms) {
      const cmd = this.makeOneCmd();
      cmd.delay = delay_ms;
      this.$emit("input", cmd);
    },
    onChangeColor(value) {
      this.style.color = value; // delay와는 다르다. 왜다른지는 파악 delays는 상위 이건, array의 아이템
      this.$emit("input", this.makeOneCmd());
    },
  },
  watch: {
    cmd: {
      deep: true,
      handler(cmd) {
        if (!cmd) return (this.textTypeSchemas = []);

        this.delay = cmd.delay;

        this.textTypeSchemas = cmd.argSchema1;

        // 현재는 텍스트마다의 스타일을 지원하는게 아니라 하나의 스타일만 지원하는데, 추후 확장 가능함
        if (0 < cmd.argSchema1.length) {
          if (!cmd.argSchema1[0].style) {
            this.style.color = null;
          } else {
            this.style.color = cmd.argSchema1[0].style.color;
          }
        }
      },
      immediate: true,
    },
  },
};
// return {
//   type: "text-anime",
//   data: {
//     text: "Hello, World!",
//     duration: 1000,
//     delay: 0,
//     easing: "easeInOutQuad",
//     fontSize: 24,
//     fontFamily: "Arial",
//     fontWeight: "normal",
//     color: "#000000",
//     backgroundColor: "#ffffff",
//     letterSpacing: 0,
//     lineHeight: 1.5,
//     textAlign: "left",
//     textShadow: {
//       offsetX: 0,
//       offsetY: 0,
//       blur: 0,
//       color: "#000000",
//     },
//     transform: {
//       translateX: 0,
//       translateY: 0,
//       rotate: 0,
//       scaleX: 1,
//       scaleY: 1,
//     },
//   },
// };
</script>

<style></style>
